import { render, staticRenderFns } from "./mod3.vue?vue&type=template&id=f40a5f58&scoped=true&"
import script from "./mod3.vue?vue&type=script&lang=js&"
export * from "./mod3.vue?vue&type=script&lang=js&"
import style0 from "./mod3.vue?vue&type=style&index=0&id=f40a5f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a5f58",
  null
  
)

export default component.exports